import { render, staticRenderFns } from "./DetalhesPlano.vue?vue&type=template&id=0b6cce1f&scoped=true"
import script from "./DetalhesPlano.vue?vue&type=script&lang=ts"
export * from "./DetalhesPlano.vue?vue&type=script&lang=ts"
import style0 from "./DetalhesPlano.vue?vue&type=style&index=0&id=0b6cce1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6cce1f",
  null
  
)

export default component.exports